import React, {useCallback, useEffect, useState} from "react";
import useEmblaCarousel from "embla-carousel-react";
import classNames from "classnames";
import {formatDMY} from "@/shared/lib/date";
import Link from "@/Layouts/Link";
import Svg from "@/Components/Svg";
import Picture from "@/Components/Picture";
import '@/Scss/Site/Main/articles.scss';

const BlogCarousel = (props) => {
    const {blogData = {}} = props;
    const {title = '', link = '', linkName = '', blog = []} = blogData;
    const [scrollSnaps, setScrollSnaps] = useState([]);
    const [selectedSnap, setSelectedSnap] = useState(0);

    const [carouselRef, emblaApi] = useEmblaCarousel(
        {loop: blog.length > 1, align: 'start'}
    );

    const scrollTo = useCallback((index) => {
        emblaApi?.scrollTo(index);
    }, [emblaApi]);

    useEffect(() => {
        if (!emblaApi) return;

        const onReInit = (api) => {
            setScrollSnaps(api.scrollSnapList());
            setSelectedSnap(api.selectedScrollSnap());
        };

        const onSelect = (api) => {
            setSelectedSnap(api.selectedScrollSnap());
        };

        onReInit(emblaApi);

        emblaApi.on('reInit', onReInit);
        emblaApi.on('select', onSelect);

        return () => {
            emblaApi.off('reInit', onReInit);
            emblaApi.off('select', onSelect);
        };
    }, [emblaApi]);

    const goToPrev = useCallback(() => {
        emblaApi?.scrollPrev();
    }, [emblaApi]);

    const goToNext = useCallback(() => {
        emblaApi?.scrollNext();
    }, [emblaApi]);

    if (blog.length === 0) return null;

    return (
        <div className={`container`}>
            <div className={`blog`}>
                <div className={`blog__head`}>
                    <p className={`blog__title`}>{title}</p>
                    <Link href={link} className={`blog__link`}>{linkName}</Link>
                </div>
                <div className={`blog__body embla`}>
                    <div ref={carouselRef} className={`embla__viewport`}>
                        <div className={`embla__container`}>
                            {blog.map((el, i) => {
                                return <Link key={el.id} href={`/blog/${el.url}`} className={`embla__slide`}>
                                    <Picture
                                        src={el.imgPreview}
                                        alt={el.h1}
                                        imageClassName={`increase`}
                                    />
                                    <div className={`embla__slideContent`}>
                                        <p className={`embla__slideContentCategory`}>{el.category}</p>
                                        <p className={`embla__slideContentTitle`}>{el.h1}</p>
                                        <p className={`embla__slideContentDate`}>
                                            {formatDMY(el.published_at)}
                                        </p>
                                    </div>
                                </Link>
                            })}
                        </div>
                    </div>
                    {blog.length > 1 && (
                        <div className={`embla__controls`}>
                            <div className={`embla__dots`}>
                                {scrollSnaps.map((_, index) => (
                                    <div
                                        key={`dot-${index}`}
                                        className={classNames('embla__dot', {
                                            'embla__dot--selected': index === selectedSnap,
                                        })}
                                        onClick={() => scrollTo(index)}
                                    >
                                    </div>
                                ))}
                            </div>
                            <div className={`embla__buttons`}>
                                <div className={`embla__prev`} onClick={goToPrev}>
                                    <Svg id={`arrowLeft`} className={`svg--arrow`} />
                                </div>
                                <div className={`embla__next`} onClick={goToNext}>
                                    <Svg id={`arrowRight`} className={`svg--arrow`} />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default BlogCarousel;
